import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { Pricing } from './components/Pricing';
import { Examples } from './components/Examples';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white text-brand-ink" data-id="element-0" data-mp="2mjzlb0sxjhkg">
      <Navbar data-id="element-1" data-mp="31c9uy3vtszrg" />
      <main data-id="element-2" data-mp="31c1ksjr388jy">
        <Hero data-id="element-3" data-mp="31cjo20c63n1d" />
        <Benefits data-id="element-4" data-mp="2wka18t6cn33b" />
        <HowItWorks data-id="element-5" data-mp="2wjqhr811w6n6" />
        <Pricing data-id="element-6" data-mp="2wj8ehrfz0s5r" />
        <Examples data-id="element-7" data-mp="2wip7v6vrtq71" />
        <Comparison data-id="element-8" data-mp="2wi5l9cv6edmo" />
        <Testimonials data-id="element-9" data-mp="28u5uwe1s0p8m" />
        <Faq data-id="element-10" data-mp="28te1n9vnj3li" />
        <FinalCta data-id="element-11" data-mp="28t4jg8gum0qd" />
      </main>
      <Footer data-id="element-12" data-mp="28s2x37udtrtc" />
    </div>;
}